import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("role"); // assuming you store 'admin' for admin

  // If no token or not admin, redirect to login
  if (!token || role !== "owner") {
    return <Navigate to="/login" replace />;
  }

  return children;
}
